module.exports = __webpack_public_path__ + "img/eight6Orange.6c396e18.jpg";